<template>
  <div>
    <Modal
      ref="modal"
      title="Message Team"
      body="Warning, this will send a message to your whole team. Use carefully. Bulk messaging must be enabled for your account before being able to send to ensure compliance with wireless network regulations. Please email support@humaniz.io to get registered. Registration usually takes 2-5 business days."
      action="Send"
      action-color="indigo"
      @close-modal="handleCancel"
      @handle-action="handleSend"
    >
      <div class="mx-auto mb-4">
        <div class="mt-6 sm:mt-5 sm:pt-5">
          <div class="mt-1 sm:mt-0">
            <div class="max-w-lg grid grid-cols-1 rounded-md border border-gray-300 p-2">
              <div class="col-span-7 flex text-indigo-600">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="cursor-pointer h-5 w-5 mr-2"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  @click="showEmoticons = !showEmoticons"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <circle cx="12" cy="12" r="9" />
                  <line x1="9" y1="9" x2="9.01" y2="9" />
                  <line x1="15" y1="9" x2="15.01" y2="9" />
                  <path d="M8 13a4 4 0 1 0 8 0m0 0h-8" />
                </svg>
              </div>
              <div class="w-full">
                <TextAreaInput
                  v-if="!showEmoticons"
                  ref="messageInput"
                  :model-value="message"
                  class="focus:ring-indigo-100 focus:border-indigo-100 block w-full sm:text-sm border-transparent rounded-md -mt-2"
                  placeholder="Enter your message..."
                  @update:model-value="message = $event"
                />
                <div v-if="showEmoticons" class="flex justify-center">
                  <Picker
                    :data="index"
                    :style="{ maxHeight: '250px', width: '100%' }"
                    :set="'apple'"
                    :show-preview="false"
                    @select="
                      message = message + `${$event.native}`;
                      showEmoticons = false;
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4 grid grid-cols-2 gap-3">
          <SelectMenu
            label="Merge Tags"
            initial-value="Select a merge tag..."
            :options="mergeTags"
            @selected-option="tag => $refs.messageInput.insertTextAtCursor(tag)"
          />
          <SelectMenu
            ref="smsTemplateselectMenu"
            label="Use existing template"
            :initial-value="smsTemplates.find(t => t.id === selectedTemplateId) || 'Select an SMS template...'"
            :options="smsTemplates.map(t => t.name)"
            @selected-option="template => setSmsTemplate(template)"
          />
        </div>
        <div class="mt-4 bg-gray-100 rounded p-6 text-sm flex justify-between">
          <div class="mt-2 text-sm leading-5 text-gray-900">Looking to create more SMS templates?</div>
          <router-link to="/settings/templates/sms" target="_blank">
            <TButton label="Template Library" color="white" />
          </router-link>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '../shared/Modal.vue';
import 'emoji-mart-vue-fast/css/emoji-mart.css';
import data from 'emoji-mart-vue-fast/data/all.json';
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast';
import TextAreaInput from '../shared/TextAreaInput.vue';

export default {
  components: {
    Modal,
    Picker,
    TextAreaInput,
  },
  data() {
    return {
      showEmoticons: false,
      index: new EmojiIndex(data),
      message: '',
      selectedTemplateId: '',
      smsTemplates: [],
      mergeTags: [
        '{{contact.name}}',
        '{{contact.first_name}}',
        '{{contact.last_name}}',
        '{{contact.email}}',
        '{{contact.phone_number}}',
        '{{contact.source}}',
        '{{contact.referral_link}}',
        '{{team.company}}',
      ],
      selectedTab: 'Merge Tags',
    };
  },
  mounted() {
    this.getSmsTemplates();
  },
  methods: {
    handleSend() {
      const self = this;
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch(`/api/teams/message`, {
        method: 'POST',
        body: JSON.stringify({
          content: self.message,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            this.$emit('handleMessageTeam');
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Team message sent',
              alertDescription: 'Your team was successfully messaged.  Use the button below to dismiss this alert.',
            });
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Team message error',
              alertDescription: data.message,
            });
          }
        });
    },
    getSmsTemplates() {
      const self = this;
      fetch(`/api/sms_templates`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => response.json())
        .then(data => {
          self.smsTemplates = data.records;
        });
    },
    setSmsTemplate(templateName) {
      const self = this;
      const selectedTemplate = self.smsTemplates.find(t => t.name === templateName);
      if (selectedTemplate && selectedTemplate.body) {
        self.message = selectedTemplate.body;
        self.selectedTemplateId = selectedTemplate.id;
      }
    },
    handleCancel() {
      this.$emit('handleMessageTeamCancel');
    },
  },
};
</script>
